import { AbstractControl } from '@angular/forms';

export function RequireMatch(control: AbstractControl) {
    const selection = control?.value;
    if (typeof selection === 'string' && selection.trim().length > 0) {
        return { incorrect: true };
    }
    return null;
}
